<template>
  <div>
    <div class="d-flex flex-column align-end flex-sm-row">
      <div class="mb-6 mb-md-12 mr-md-4">
        <div class="text-h5 text-md-h4">
          Консультируйтесь с врачами онлайн
        </div>
        <div class="mt-4 text-body-1 text-md-landing-body-1">
          Записывайтесь к врачам на телемед-консультации через ПроДокторов и общайтесь в МедТочке.
        </div>
      </div>

      <v-img
        class="align-self-end"
        alt="Онлайн консультация"
        :height="$display.mdAndUp.value ? 320 : 225"
        :width="$display.mdAndUp.value ? 500 : 320"
        :src="`images/features/patient/online_consultation${$display.mdAndUp.value ? '' : '_mobile'}.png`"
        :srcset="!$display.mdAndUp.value
          ? 'images/features/patient/online_consultation_mobile.png 1x,' +
            'images/features/patient/online_consultation_mobile_3x.png 3x'
          : undefined"
      />
    </div>
    <v-row>
      <v-col
        v-for="(item, index) in telemedFeatures"
        :key="item.title"
        :cols="$display.mdAndUp.value ? 6 : 12"
        :class="{
          'pr-3 pb-3': index === 0 && $display.mdAndUp.value,
          'pl-3 pb-3': index === 1 && $display.mdAndUp.value,
          'pr-3 pt-3': index === 2 && $display.mdAndUp.value,
          'pl-3 pt-3': index === 3 && $display.mdAndUp.value
        }"
      >
        <v-sheet class="bg-ui-kit-bg-secondary rounded-xl pa-6 pb-8 h-100">
          <v-sheet
            width="36"
            height="36"
            class="d-flex justify-center align-center mb-4 bg-primary rounded-circle"
          >
            <v-icon
              size="20"
              class="text-ui-kit-bg-gray-0"
            >
              {{ item.icon }}
            </v-icon>
          </v-sheet>

          <div>
            <div :class="$display.mdAndUp.value ? 'landing-card-title-1' : 'landing-subtitle-1'">
              {{ item.title }}
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <div class="d-flex justify-center mt-4 mt-md-12">
      <LandingFeatureBtn
        text="Выбрать врача"
        variant="tonal"
        target="_blank"
        width="360"
        :href="useRuntimeConfig().public.pdUrl"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'

const telemedFeatures = [
  {
    icon: 'ui-icon-rating-star-outline',
    title: 'Обращайтесь к лучшим врачам со всей России: не ограничивайте выбор только своим городом',
  },
  {
    icon: 'ui-icon-map-pin',
    title: 'Подключайтесь к консультации в любом удобном месте: дома, на работе, в путешествии',
  },
  {
    icon: 'ui-icon-message-circle',
    title: 'Врач посмотрит анализы, даст рекомендации, а вы сможете узнать второе мнение специалиста',
  },
  {
    icon: 'ui-icon-lock-key',
    title: 'Консультация проходит в вашем личном кабинете МедТочка и защищена шифрованием',
  },
]

const $display = useDisplay()
</script>
